export default "__VITE_ASSET__Ccv4uP2k__"